<template>
  <div class="news-box">
    <div class="news-box-title">
      <div class="news-box-title-left">
        <div class="news-box-title-text">
          <img
            v-if="type == 'news'"
            :src="require(`@/static/news/hot.png`)"
            alt=""
          />
          <img
            v-if="type == 'qi'"
            :src="require(`@/static/news/qi.png`)"
            alt=""
          />
          <span v-if="type == 'news'"> 热门新闻</span>
          <span v-if="type == 'qi'"> 企业新闻</span>
        </div>
      </div>
      <div>
        <!-- <router-link class="router-link lookmore" to="/"
          ><span class="margin">查看更多</span>
          <i class="el-icon-caret-right"></i
        ></router-link> -->
      </div>
    </div>
    <div class="news-box-content">
      <div
        @click="handleClick(item)"
        class="news-box-content-item"
        v-for="(item, index) in newsList"
        :key="index"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>
<script>
import { getHotNews,getQiyeNews } from "@/api/modules/home";
export default {
  name: "news-box",
  props: {
    type: {
      type: String,
      default: "news",
    },
  },
  data(){
    return {
      newsList: [],
    }
  },
  mounted(){
    if(this.type == 'qi'){
      this.getQiNews();
    }else{
      this.getNewsList();
    }
  },
  methods: {
    getNewsList(){
      getHotNews().then(res => {
        this.newsList = res.data.data.data
      });
    },
    getQiNews(){
      getQiyeNews().then(res => {
        this.newsList = res.data.data.data
      });
    },
    // 点击新闻
    handleClick(item) {
      this.$router.push({
        path: "/ruitian-news/news-detail",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script> 
<style lang="scss" scoped>
.news-box {
  width: 430px;
  border-radius: 0px 0px 0px 0px;
  border: 1px solid #d1d5e3;

  .news-box-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #d1d5e3;

    .news-box-title-text {
      display: flex;
      align-content: center;
      font-weight: bold;
      font-size: 20px;
      color: #00112b;
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        padding-top: 5px;  
        vertical-align: middle;
      }
    }
    .lookmore {
      font-weight: 400;
      font-size: 16px;
      color: #afafaf;
      .margin {
        display: inline-block;
        margin-right: 10px;
      }
    }
  }
  .news-box-content {
    padding: 25px 25px 10px;
    height: 495px;
    .news-box-content-item {
      font-weight: 400;
      font-size: 16px;
      color: #00112b;
      display: -webkit-box; /* 使用WebKit的盒子模型 */
      -webkit-line-clamp: 1; /* 限制显示两行 */
      -webkit-box-orient: vertical; /* 设置盒子方向为垂直 */
      overflow: hidden; /* 超出部分隐藏 */
      text-overflow: ellipsis; /* 超出部分显示省略号 */
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>